var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"dir":"ltr"}},[_c('organization-chart',{attrs:{"datasource":_vm.chartData,"pan":_vm.druggable},on:{"node-click":_vm.clickedNote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }